export default "__VITE_ASSET__faea5f7e__"